import { combineReducers } from 'redux'
import theme from './themeStore'

export default combineReducers({ theme })
